<h1 mat-dialog-title translate>Delete group</h1>
<div mat-dialog-content translate>Are you sure you want to delete this group? All it's contents will be moved to the "Ungrouped" default group.</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()"><span translate>Cancel</span></button>
  <button mat-button color="primary" [mat-dialog-close]="data"><span translate>Delete</span></button>
</div>
